import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdatePushReportRecipientForUserMutation } from "org/user/queries/useUpdatePushReportRecipientForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { PushReportRecipientRow } from "./useUserPushReportsRecipientListTable";

interface UseReplacePushReportRecipientUtilsProps {
    userId: number;
    selectedRows: Row<PushReportRecipientRow>[];
    deselectAll: () => void;
}

export function useReplacePushReportRecipientUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplacePushReportRecipientUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdatePushReportRecipientForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = async (userOrGroup: UserOrUserGroupOverview) => {
        const pushReportConfigurationIds = selectedRows.map(
            (row) => row.original.id
        );
        const newUserId = userOrGroup.id;
        try {
            await mutateAsync({
                userId,
                data: { newUserId, pushReportConfigurationIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        openReplaceUserModal: () => setIsModalOpen(true),
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
